// @flow
export const SET_TOKEN_FROM_COOKIE: string = "SET_TOKEN_FROM_COOKIE";


// WEBPACK FOOTER //
// ./src/Constants/Global/cookieWorkerConstants.js